module.exports = __webpack_public_path__ + "img/Freelance_boja.1d1a5f3.svg";